
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import * as contact from '~/store/modules/contact'
import * as faq from '~/store/modules/faq'

import Tick2 from '~/components/Icons/TickAlt.vue'
import HelpOptionspartner from '~/components/LandingPage/HelpOptionspartner.vue'
import LottieAnimation from 'lottie-web-vue'
import FaqList from '~/components/Faq/FaqList.vue'
import BuildToRentContactForm from '~/components/ContactForm/BuildToRent.vue'
import { ContactForm } from '~/lib/contact/ContactForms'

const Faq = namespace(faq.name)
const Contact = namespace(contact.name)

@Component({
  components: {
    FaqList,
    Tick2,
    HelpOptionspartner,
    LottieAnimation,
    BuildToRentContactForm
  },
  head(): any {
    return {
      title: `${this.brand.name} Internet - Build To Rent`,
      meta: [
        {
          name: 'description',
          content: `Australia’s end-to-end internet solution for the Build to Rent sector.`
        }
      ]
    }
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  }
})
export default class BuildToRent extends Vue {
  @Faq.Getter
  byType
  
  @Contact.Action
  create
  
  @Contact.Action
  validate

  error = false

  sending = false

  sent = false

  async mounted() {
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e);
    }
  }

  async handleSubmit(event: ContactForm) {
    try {
      this. sending = true
      const token = await this.$recaptcha.getResponse()
      await this.validate({...event, token})
      await this.$recaptcha.reset()
      await this.create(event)

      this.sending = false;
      this.sent = true;
    } catch(e: unknown) {
      this.error = true
    }
  }
}
